/**
 * 环境配置
 *
 * 通过访问路径区分医学会环境与产品环境：
 *   - 医学会精准推送：路径含 precisionPushM
 *   - 产品精准推送：其余路径（如 precisionPush）
 *
 * 环境相关逻辑的统一数据源，扩展时只需修改此文件。
 */

/** 医学会环境的路由路径标识 */
const MEDICAL_ASSOCIATION_ROUTE_MARKER = 'precisionPushM'

/**
 * 是否为医学会环境
 * 依据访问路径是否包含医学会路由标识（模块加载时计算一次）
 */
export const isMedicalAssociationEnv = window.location.pathname.includes(
  MEDICAL_ASSOCIATION_ROUTE_MARKER
)

/** 产品环境 increment 模块 API 前缀 */
export const DAS_MANAGER_PREFIX = '/das-manager'
export const DAS_WEB_CENTER_PREFIX = '/das-web-c'
export const DAS_ASIS_PREFIX = '/das-asis'

/** 医学会环境 increment 模块 API 前缀 */
export const YXH_DAS_API_PREFIX = '/yxh-das-api'
export const YXH_DAS_WEB_CENTER_PREFIX = '/yxh-das-web-c'
export const YXH_DAS_ASIS_PREFIX = '/yxh-das-asis'

/** Portal 精准推送模块标识（医学会 getAllMenuByMagazineIdAndUser） */
export const PORTAL_PRECISION_MODULE = 'precision'

/** Portal 产品环境菜单 pid（usermagazinecentermenu） */
export const PORTAL_PRECISION_PID = 'precisionPush'
